import { Promises } from "@opendaw/lib-runtime";
export var StorageWalk;
(function (StorageWalk) {
    const ProgressInterval = 64;
    StorageWalk.walk = async (root, progress) => {
        const files = [];
        const failures = [];
        const visit = async (folder, prefix) => {
            for await (const handle of folder.values()) {
                const path = `${prefix}${handle.name}`;
                if (handle.kind === "directory") {
                    await visit(handle, `${path}/`);
                    continue;
                }
                const { status, value } = await Promises.tryCatch(handle.getFile());
                if (status === "rejected") {
                    failures.push(path);
                    continue;
                }
                files.push({ path, size: value.size });
                if (files.length % ProgressInterval === 0) {
                    progress(files.length);
                }
            }
        };
        await visit(root, "");
        progress(files.length);
        return { files, failures };
    };
    StorageWalk.totalSize = (files) => files.reduce((sum, { size }) => sum + size, 0);
})(StorageWalk || (StorageWalk = {}));
